export default "__VITE_ASSET__CimVHhd3__"